import { render, staticRenderFns } from "./ModalContentSubBukuBesarBulan.vue?vue&type=template&id=ec6327ba"
import script from "./ModalContentSubBukuBesarBulan.vue?vue&type=script&lang=js"
export * from "./ModalContentSubBukuBesarBulan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports